import { DELETE_ALL_MESSAGES, DELETE_CONVERSATION, DELETE_MESSAGES_BY_ID, DELETE_PARTICIPANTS, DELETE_UNREAD_MSG_COUNT, SELECTED_CONVERSATION, UPDATE_CONVERSATIONS, UPDATE_CUSTOMERDETAILS, UPDATE_INITIAL_STATE, UPDATE_MESSAGES_BY_ID, UPDATE_PAGE, UPDATE_PARTICIPANTS, UPDATE_UNREAD_MSG_COUNT } from "../action-types/conversationActionTypes";


export function updateConversations(data: any) {
    return {
        type: UPDATE_CONVERSATIONS,
        payload: data
    }
}

export function updateMessagesById(data: any) {
    return {
        type: UPDATE_MESSAGES_BY_ID,
        payload: data
    }
}

export function deleteConversationById(data: any) {
    return {
        type: DELETE_CONVERSATION,
        payload: data
    }
}

export function selectedConversation(data: any) {
    return {
        type: SELECTED_CONVERSATION,
        payload: data
    }
}

export function updateParticipants(data: any) {
    return {
        type: UPDATE_PARTICIPANTS,
        payload: data
    }
}

export function updateCustomerDetails(data: any) {
    return {
        type: UPDATE_CUSTOMERDETAILS,
        payload: data
    }
}

export function deleteMessagesById(data: any) {
    return {
        type: DELETE_MESSAGES_BY_ID,
        payload: data
    }
}

export function deleteParticipants(data: any) {
    return {
        type: DELETE_PARTICIPANTS,
        payload: data
    }
}

export function updateUnreadMsgCount(data: any) {
    return {
        type: UPDATE_UNREAD_MSG_COUNT,
        payload: data
    }
}

export function deleteUnreadMsgCount(data: any) {
    return {
        type: DELETE_UNREAD_MSG_COUNT,
        payload: data
    }
}

export const deleteAllMessages = () => {
    return {
        type: DELETE_ALL_MESSAGES,
    }
}

export const updateInitialState = () => {
    return {
        type: UPDATE_INITIAL_STATE
    }
}

export const updatePage = (data: any) => {
    return {
        type: UPDATE_PAGE,
        payload: data
    }
}